import React from "react";
import { PeopleBadge } from "@dreamhub/designsystem/icons";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import { cn } from "@/utils/utils";

interface StakeholdersApprovalEmptyStateProps {
  onOpenRelatedQuestionnaire: () => void;
  labels: { title: string; subtitle: string; button: string };
  className?: string;
}

const StakeholdersApprovalEmptyState: React.FC<
  StakeholdersApprovalEmptyStateProps
> = ({ onOpenRelatedQuestionnaire, labels, className }) => {
  return (
    <div
      className={cn(
        "relative flex flex-col w-full pt-32 items-center",
        className
      )}
    >
      <div className="flex flex-col items-center">
        <PeopleBadge />
        <div className="flex flex-col gap-2 mb-6 items-center">
          <Text variant="body">{labels.title}</Text>
          <Text variant="bodyTertiary">{labels.subtitle}</Text>
        </div>
        <Button variant="secondary" onClick={onOpenRelatedQuestionnaire}>
          {labels.button}
        </Button>
      </div>
    </div>
  );
};

export default StakeholdersApprovalEmptyState;
